import { Store } from 'src/store/index';

const getSelectedProductAttributes = (store: Store) => store.design.selectedProductAttributes;

export default getSelectedProductAttributes;
